











































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import moment from 'moment'
    import appconst from '@/lib/appconst';
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'

    class PageOrderRequest extends PageRequest {
        orderStatus?: number;
        userCode: string;
        SearchInfo: string;
        BeginTime?: Date;
        EndTime?: Date;
        storeId?: number;
        constructor() {
            super();
            this.orderStatus = null;
        }
    }

    @Component({
        name: "backdistributionorderlist",
        components: {}
    })
    export default class backdistributionorder extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        siteType = Enums.getEnum(Enums.ShopSiteType, true);
        spinShow: boolean = false;
        shopOrderStatus = Enums.getEnum(Enums.DistributionOrderStatus, true);
        Dispaly: string = "";
        CList: Array<any> = [];
        isLoadPrintList: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        successModelShow: boolean = false;
        failureModelShow: boolean = false;
        automaticJump: boolean = true;
        Total: number = 0;
        async searchPage() {
            this.$store.state.backdistributionorder.currentPage = 1;
            this.getpage();
        }
        get list() {
            return this.$store.state.backdistributionorder.list;
        };
        get loading() {
            return this.$store.state.backdistributionorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backdistributionorder/setCurrentPage', page);
            this.getpage();
        }

        enter() {
            this.getpage();
        }




        pagesizeChange(pagesize: number) {
            this.$store.commit('backdistributionorder/setPageSize', pagesize);
            this.getpage();
        }

        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true }); 
            this.storeaddressList.push(a);
        }


        async getpage() {
            //this.$store.state.backdistributionorder.isPacked = true;
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'backdistributionorder/getAll',
                data: this.pagerequest
            });
            this.Total = this.$store.state.backdistributionorder.totalCount;
            var _this: any = this;
            _this.$previewRefresh();
        }

        get pageSize() {
            return this.$store.state.backdistributionorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backdistributionorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backdistributionorder.currentPage;
        }



        async cancel(id: number) {
            this.$Modal.confirm({
                title: "取消订单", content: "是否确认取消订单？", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'frontdistributionorder/CancleOrder',
                        data: { id: id }
                    }).finally(() => {
                        this.getpage();
                    });
                }
            });

        }


        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }

        JumpToUrl(val: string) {
          //  var url = "http://localhost:1337/#/" + "shopdetailDisplay/goodsdetail?id=" + val;
            var url = "https://warehouse.qianchanchan.com/#/" + "shopdetailDisplay/goodsdetail?id=" + val;
            window.open(url, '_blank')
        }



        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            },
            {
                title: '仓库',
                key: 'warehouseName',
                width: 150,
            },
            {
                title: '用户编码',
                key: 'userCode',
                width: 150,
            },
            {
                title: '订单状态',
                width: 100,
                key: 'distributionOrderStatus',
                render: (h: any, params: any) => {

                    return h('div', [h('p', Enums.DistributionOrderStatus.filter(function (item) { return item.value == params.row.distributionOrderStatus })[0].name), [h('p', { style: { color: 'red' } })]]
                    )
                }
            },
            {
                title: '采购订单编号',
                key: 'purchaseOrderNumber',
                width: 200,
            },
            {
                title: '采购物流编号',
                key: 'purchaseLogisticsNumber',
                width: 220,
            },
            {
                title: '商品信息',
                width: 400,
                render: (h: any, params: any) => {
                    return h('div', [

                        h('p', [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: params.row.productImgUrl,
                                    preview: params.row.purchaseOrderNumber,
                                    "preview-text": params.row.purchaseOrderNumber + "-" + params.row.title
                                }
                            }),
                            (h('a', { on: { click: () => { this.JumpToUrl(params.row.productId) } } }, params.row.title)), h('font', { style: { color: "red" } }, '*'), params.row.productCount, h('p', { style: { color: "red" } }, "货号：" + params.row.skuCode)]),
                    ])
                }
            },
            {
                title: '支付积分',
                key: 'totalAmount',
                width: 100,
         
            },

            {
                title: '创建时间',
                key: 'creationTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
                }
            },


            {
                title: '更新时间',
                key: 'lastModificationTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.lastModificationTime ? DateUtils.formatLongDate(new Date(params.row.lastModificationTime)) : '');
                }
            },

            {
                title: '操作',
                width: 170,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var shopOrderStatus = Enums.DistributionOrderStatus.filter(function (item) { return item.value == data.distributionOrderStatus })[0].name;
                    var _this = this;
                    var menu = [];
                    return h('div', [
                     
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '100px',
                                display: (shopOrderStatus == "已发货") ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.cancel(data.id);
                                }
                            }

                        }, "取消订单"),

                    ]);
                }
            }]

        async created() {
            this.getpage();
            this.getData();
        }
    }
